import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import ShiftEntity from "../../../../domain/entities/ShiftEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ShiftDto from "../../../dto/ShiftDto";
import { GetUserReportResponse } from "../../../../domain/repositories/ReportRepository";
import { UserType } from "../../../../domain/entities/UserEntity";

const getUserReportApiIpml = async (_: {
    userId: String,
    role: UserType,
    startDate: Date,
    endDate: Date,
}): Promise<Either<ErrorEntity, GetUserReportResponse>> => {
    try {
        const relativeUrl: string = `/dashboard/data?start_date=${_.startDate.toISOString().split("T")[0]}&end_date=${_.endDate.toISOString().split("T")[0]}&valet_id=${_.userId}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const shifts = response.valet_turns_detail.turns.map((shift: any) => ShiftDto.fromJSON(shift));
        return right({ 
            shifts,
            assistedShifts: response.valet_attendance_stats.confirmed_attendance,
            missedShifts:  response.valet_attendance_stats.rejected_service,
            pendingShifts: response.valet_attendance_stats.not_confirmed_attendance,
            workedHours: response.work_hours_stats.total_worked_hours,
         });
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default getUserReportApiIpml;